import { cloneDeep } from 'lodash';

import { DBDocSchema } from '../../../generic/db-doc/db-doc-schema';
import { GenericDialedCallLog } from '../../dialed-call-log/generic/any-dialed-call-log';
import { OutboundCallSessionParticipant } from '../outbound-call-session-participant/outbound-call-session-participant';

import { OutboundCallSessionConstructor } from './outbound-call-session-constructor';
import { OutboundCallSessionSchema } from './outbound-call-session-schema';

export class OutboundCallSession extends GenericDialedCallLog {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected conferenceSid?: string;

  protected participant!: OutboundCallSessionParticipant;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: OutboundCallSessionConstructor) {
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(validationResult: import('joi').ValidationResult): OutboundCallSession {
    return new OutboundCallSession(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize(): any {
    return super.serialize(OutboundCallSession.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): DBDocSchema {
    return new OutboundCallSessionSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getConferenceSid(): string | undefined {
    return cloneDeep(this.conferenceSid);
  }

  public getParticipant(): OutboundCallSessionParticipant {
    return cloneDeep(this.participant);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Did Dial
  /////////////////////////////////////////////////////////////////////////////

  public didDial(): boolean {
    return true;
  }
}
